enum TextInputShortType {
    TEXT = 'text',
    PASSWORD = 'password',
    NUMBER = 'number'
}

export default TextInputShortType;